import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

interface TipProps {
	top: number;
	left: number;
	width: number;
	height: number;
	actived: boolean;
	widthContainer?: string;
	withoutBreakLine?: boolean;
}

export const Container = styled.div`
	position: relative;
	max-width: 400px;
	word-break: break-word;
	width: fit-content;
`;

export const Tip = styled.div<TipProps>`
	position: fixed;
	font-family: ${tokens.font_family_primary};
	display: ${({ actived }) => (actived ? 'block' : 'none')};
	border-radius: 4px;
	left: ${({ left, width }) => left + width / 2}px;
	transform: translateX(-50%);
	padding: 6px;
	color: white;
	background: ${tokens.color_gray_dark};
	font-size: 14px;
	line-height: 1;
	z-index: 9999;
	top: ${({ top, height }) => top - height - 8}px;
	width: ${({ widthContainer }) => widthContainer};
	white-space: ${({ withoutBreakLine }) => withoutBreakLine && 'nowrap'};

	&::before {
		content: ' ';
		left: 50%;
		border: solid transparent;
		height: 0;
		width: 0;
		position: absolute;
		pointer-events: none;
		border-width: 6px;
		margin-left: -6px;
		top: 100%;
		border-top-color: ${tokens.color_gray_dark};
	}
`;
